<template>
  <div>
    <filter-manager
      ref="filterRef"
      v-model="filterModel"
      class="mb-4 p-4"
      :display-advanced="false"
      :filters="filtersConfig"
      search-container-class="d-flex justify-content-end align-items-end"
      search-text=""
    >
      <div
        class="col-12 col-md-3 d-flex align-items-end mt-4"
        :class="
          isIntervenedServiceVisible(this.statusId) ? 'offset-md-9 mt-3' : ''
        "
      >
        <action-button
          class="search mb-2 col-12 col-md-8 offset-md-4"
          i="fas fa-search"
          :style="{ width: isMobile ? '100%' : '' }"
          text="Buscar"
          variant="success"
          @click="onSearchHandler"
        />
      </div>
    </filter-manager>
    <div v-if="showExtraActions" class="row justify-content-end mr-1">
      <a
        class="ml-3 font-16"
        href="#"
        @click.prevent="onDownloadAllDocuments()"
      >
        <i class="fas fa-file-download mr-2" />
        <u>Descargar Certificaciones en Masa</u>
      </a>
    </div>
    <result-row
      :bill="bill"
      :data="billDetails"
      :is-read-only="isReadOnly"
      :show-extra-actions="showExtraActions"
    />
    <custom-result-not-found
      v-if="billDetails.length == 0"
      :text="'No hay información disponible.'"
    />
    <pagination
      v-if="pagination.totalItemCount > pagination.pageSize"
      :data="pagination"
      :show-input-to-go="true"
      show-text
      @page-size-change="changePageSize"
      @pagination-go-page="goToPageHandler"
    />
  </div>
</template>
<script>
import FilterManager from 'FilterManager';
import ActionButton from 'ActionButton';
import Pagination from 'pagination';
import {
  getBillingDetailInitFilters as _getBillingDetailInitFilters,
  getDisicplinesByServiceTypeId as _getDisicplinesByServiceTypeId,
  getSpecialistsByDisciplineTypeId as _getSpecialistsByDisciplineTypeId,
  getBillingDetails as _getBillingDetails,
  getAllContractServiceDocument as _getAllContractServiceDocument,
} from '@/services/provider/billing-contract.api';
import billingStatus from '@/utils/constants/billingStatus';
import billingAlerts from '@/utils/constants/billingAlerts';
import ResultRow from './components/ResultRow.vue';
import { name as appModuleName } from '@/store/modules/app';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import roles from '@/utils/constants/roles.js';
import { mapGetters } from 'vuex';
import storeMixin from '@quisit/mipe-utils/mixins/storeGenerator';
import CustomResultNotFound from 'custom-result-not-found';

export default {
  name: 'ContractSearch',
  mixins: [alertMixin, storeMixin],
  components: {
    FilterManager,
    Pagination,
    ResultRow,
    ActionButton,
    CustomResultNotFound,
  },
  data() {
    return {
      billId: 0,
      billingInfoTabIndex: 1,
      filterModel: {
        serviceType: null,
        disciplineType: null,
        specialist: null,
        alertType: null,
        studentSie: null,
        contractNumber: null,
        intervenedService: null,
        withAdjustment: null,
      },
      pagination: {
        pageIndex: 1,
        pageSize: 15,
        totalItemCount: 0,
        showPageSizeOptions: true,
        pageSizeOptions: [15, 20, 25, 30],
      },
      billDetails: [],
      filterOptions: {
        serviceTypes: [],
        disciplineTypes: [],
        specialists: [],
        alertTypes: [],
        signatureTypes: [],
        intervenedServiceOptions: [
          {
            id: true,
            name: 'Si',
          },
          {
            id: false,
            name: 'No',
          },
        ],
        withAdjustmentOptions: [
          {
            id: true,
            name: 'Si',
          },
          {
            id: false,
            name: 'No',
          },
        ],
      },
      currentPage: 1,
    };
  },
  props: {
    bill: {
      type: Object,
      default: () => {},
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
    statusId: {
      type: Number,
      default: () => 0,
    },
  },
  computed: {
    ...mapGetters(appModuleName, {
      isMobile: 'getIsMobileDensity',
    }),
    headerConfig() {
      return {
        title: 'Detalle de Factura',
        icon: 'fas fa-user-tie',
        routes: ['Inicio', 'Proveedor', 'Historial de Facturas', 'Ver Factura'],
      };
    },
    filtersConfig() {
      return [
        {
          name: 'serviceType',
          label: 'Servicio:',
          component: 'CustomDropDown',
          value: this.filterModel.serviceType,
          options: this.filterOptions.serviceTypes,
          placeholder: 'Seleccione',
          fieldName: 'name',
          fieldKey: 'id',
          class: 'col-12 col-md-3',
          clearable: true,
        },
        {
          name: 'disciplineType',
          label: 'Disciplina:',
          component: 'CustomDropDown',
          value: this.filterModel.disciplineType,
          options: this.filterOptions.disciplineTypes,
          placeholder: 'Seleccione',
          fieldName: 'name',
          fieldKey: 'id',
          class: 'col-12 col-md-3',
          clearable: true,
        },
        {
          name: 'specialist',
          label: 'Especialista:',
          component: 'CustomDropDown',
          value: this.filterModel.specialist,
          options: this.filterOptions.specialists,
          placeholder: 'Seleccione',
          fieldName: 'name',
          fieldKey: 'id',
          class: 'col-12 col-md-3',
          clearable: true,
        },
        {
          name: 'alertType',
          label: 'Alertas:',
          component: 'CustomDropDown',
          value: this.filterModel.alertType,
          options: this.alertTypesFilter,
          placeholder: 'Seleccione',
          fieldName: 'name',
          fieldKey: 'id',
          class: 'col-12 col-md-3',
          clearable: true,
        },
        {
          name: 'studentSie',
          label: 'SIE:',
          component: 'CustomInput',
          value: this.filterModel.studentSie,
          placeholder: 'Escriba número de SIE',
          fieldName: 'name',
          fieldKey: 'id',
          class: 'col-12 col-md-3',
          clearable: true,
        },
        {
          name: 'contractNumber',
          label: 'Número de Contrato:',
          component: 'CustomInput',
          value: this.filterModel.contractNumber,
          placeholder: 'Escriba número de Contrato',
          fieldName: 'name',
          fieldKey: 'id',
          class: 'col-12 col-md-3',
          clearable: true,
        },
        {
          name: 'signatureType',
          component: 'CustomDropDown',
          options: this.filterOptions.signatureTypes,
          label: 'Tipo de Firma:',
          placeholder: 'Seleccione',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          class: 'col-12 col-md-3',
        },
        {
          name: 'intervenedService',
          label: 'Servicio Intervenido:',
          component: 'CustomDropDown',
          value: this.filterModel.intervenedService,
          placeholder: 'Seleccione',
          fieldName: 'name',
          fieldKey: 'id',
          options: this.filterOptions.intervenedServiceOptions,
          class: 'col-12 col-md-3',
          clearable: true,
          visible: this.isIntervenedServiceVisible(this.statusId),
        },
        // {
        //   name: 'withAdjustment',
        //   label: 'Contiene Ajuste:',
        //   component: 'CustomDropDown',
        //   value: this.filterModel.withAdjustment,
        //   placeholder: 'Seleccione',
        //   fieldName: 'name',
        //   fieldKey: 'id',
        //   options: this.filterOptions.withAdjustmentOptions,
        //   class: 'col-12 col-md-3',
        //   clearable: true,
        // },
      ];
    },
    showExtraActions() {
      return (
        this.bill.statusId !== billingStatus.Preliminar &&
        this.bill.statusId !== billingStatus.PendienteIntervencion &&
        this.userRoleId === roles.Pre_Interventor_RP
      );
    },
    isServiceModelSelected() {
      return this.filterModel.serviceType;
    },
    isDisciplineModelSelected() {
      return this.filterModel.disciplineType;
    },
    serviceWithoutInterventionExists() {
      return this.billDetails?.some((x) => !x.checkedFlag);
    },
    hasPersistedCurrentBilling() {
      return (
        parseInt(this.$route.params.billId) ===
        parseInt(this.moduleData?.ContractSearch?.billId)
      );
    },
    alertTypesFilter() {
      let alertTypes = this.filterOptions.alertTypes;

      if (this.bill.statusId !== billingStatus.Preliminar)
        alertTypes = alertTypes.filter(
          (x) =>
            x.id !== billingAlerts.NotFinalized &&
            x.id !== billingAlerts.WithoutVisitCertification
        );

      return alertTypes;
    },
  },
  methods: {
    async getDetailTabInitFilters() {
      await this.fetchServicesAndAlertTypes();
      await this.fetchDisciplines();
      await this.fetchSpecialists();
    },
    async fetchServicesAndAlertTypes() {
      let { data } = await _getBillingDetailInitFilters(this.billId);

      if (!data) return;

      this.filterOptions.serviceTypes = data.serviceTypes;
      this.filterOptions.alertTypes = data.alertTypes;
      this.filterOptions.signatureTypes = data.signatureTypes;
    },
    async fetchDisciplines() {
      let { data } = await _getDisicplinesByServiceTypeId(this.billId);

      if (!data) return;

      this.filterOptions.disciplineTypes = data;
    },
    async fetchSpecialists() {
      let { data } = await _getSpecialistsByDisciplineTypeId(this.billId);

      if (!data) return;

      this.filterOptions.specialists = data;
    },
    async fetch() {
      let { data } = await _getSpecialistsByDisciplineTypeId(this.billId);

      if (!data) return;

      this.filterOptions.specialists = data;
    },
    async onSearchHandler(pageIndex = 0) {
      // Set Page One
      this.pagination.pageIndex = pageIndex === 0 ? 1 : pageIndex;
      let payload = {
        billId: this.billId,
        monthNumber: this.bill.monthNumber,
        serviceTypeId: this.filterModel.serviceType?.id,
        disciplineTypeId: this.filterModel.disciplineType?.id,
        specialistId: this.filterModel.specialist?.id,
        alertId: this.filterModel.alertType?.id,
        studentSie: this.filterModel.studentSie,
        contractNumber: this.filterModel.contractNumber,
        pageIndex: this.pagination.pageIndex,
        pageSize: this.pagination.pageSize,
        intervenedService: this.filterModel.intervenedService?.id,
        withAdjustment: this.filterModel.withAdjustment?.id,
        signatureTypeId: this.filterModel.signatureType?.id,
      };
      await _getBillingDetails(payload).then(({ data }) => {
        this.billDetails = data.data;
        this.pagination = {
          ...this.pagination,
          count: data.count,
          currentPage: data.currentPage,
          pageCount: data.pageCount,
          totalItemCount: data.totalItemCount,
        };
        this.currentPage = data.currentPage;
      });
    },
    isIntervenedServiceVisible(statusId) {
      return (
        statusId !== null &&
        statusId === billingStatus.EnProcesoIntervencion &&
        this.userHasPermissions(
          'rempro.providers.billing.details.intervenedService'
        )
      );
    },
    async goToPageHandler(page) {
      await this.onSearchHandler(page);
    },
    async changePageSize(size) {
      this.pagination.pageSize = size;
      await this.onSearchHandler();
    },
    async onDownloadAllDocuments() {
      const payload = this.billDetails.map((b) => {
        return {
          billNumber: this.bill.billNumber,
          contractId: b.contractId,
          serviceTypeId: b.serviceTypeId,
          visitSummaryId: b.visitSummaryId,
        };
      });
      return await _getAllContractServiceDocument(payload).catch((err) =>
        this.ShowToast('', err.response?.data?.message, 'error')
      );
    },
    onPushVisitRegistryHandler() {
      this.persistData(['pagination', 'billDetails'], true);
    },
    onResetData() {
      this.persistData(['pagination', 'billDetails'], true);
    },
    checkPersistedInformation() {
      if (this.hasPersistedCurrentBilling) return;

      this.onResetData();
      this.billId = parseInt(this.$route.params.billId);
    },
  },
  async created() {
    this.checkPersistedInformation();

    await this.getDetailTabInitFilters().then(() =>
      this.onSearchHandler(this.currentPage)
    );
  },
  async mounted() {
    this.billId = this.$route.params.billId;
    this.$root.$on('on-push-visit-registry', () =>
      this.onPushVisitRegistryHandler()
    );
  },
};
</script>
<style lang="scss" scoped></style>
